import React, { FunctionComponent } from 'react';
import { css } from 'aphrodite/no-important';
import { FormattedMessage } from 'react-intl';
import { Paragraph } from '@trainline/depot-web';

import {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
} from '@contactcentre-web/common/Modal';
import Button from '@contactcentre-web/common/Button';

import { BlockReason } from './ProfileStatus';
import messages from './messages';
import styles from './styles';

interface Props {
  visible: boolean;
  onClose: () => void;
  blockReason: BlockReason | null;
  unblock: () => void;
}

const UnblockAccount: FunctionComponent<Props> = ({ visible, onClose, blockReason, unblock }) => {
  const handleSubmit = () => {
    unblock();
    onClose();
  };

  return visible ? (
    <Modal onClose={onClose}>
      <ModalHeader>
        <ModalTitle>
          <FormattedMessage {...messages.unblockAccountTitle} />
        </ModalTitle>
      </ModalHeader>
      <ModalBody>
        <div className={css(styles.blockReason)}>
          <Paragraph fontWeight="semibold">
            <FormattedMessage {...messages.blockedReason} />
            :&nbsp;
          </Paragraph>
          <Paragraph>
            <FormattedMessage
              {...(blockReason === BlockReason.PaymentFailed
                ? messages.paymentFailed
                : messages.fraudThresholdExceeded)}
            />
          </Paragraph>
        </div>
        <Paragraph>
          <FormattedMessage {...messages.unblockAccountMessage} />
        </Paragraph>
      </ModalBody>
      <ModalFooter>
        <div className={css(styles.buttonContainer)}>
          <Button variant="tertiary" size="small" onClick={onClose}>
            <FormattedMessage {...messages.buttonCancel} />
          </Button>
          <Button variant="secondary" size="small" onClick={handleSubmit}>
            <FormattedMessage {...messages.buttonUnblock} />
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  ) : null;
};

export default UnblockAccount;
